import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { Button } from "@progress/kendo-react-buttons";
import { AuthContext } from "./AuthContext";
import { SvgIcon } from "@progress/kendo-react-common";
import { bellIcon, chevronDownIcon } from '@progress/kendo-svg-icons';

class Nav extends Component {
  static contextType = AuthContext;

  handleNotificationClick() {
    this.props.history.push('/eoirequest');
  }

  componentDidMount() {
    // Expose the logout function globally
    window.logout = this.context.logout;
  }

  cobrowseSupportCode() {
    return (
      <div className="generate-code" title="Generate a Support Code">
        {" "}
        <span
          className="k-icon k-i-track-changes-accept k-icon-64"
          onClick={window["showSessionCode"]}
        ></span>
      </div>
    );
  }
  state = {
    isBoxVisible:false
  };
  toggleBox = () => {
    this.setState(prevState => ({ isBoxVisible: !prevState.isBoxVisible }));
  };
  render() {
    const { isBoxVisible } = this.state;
    const navLinks = document.querySelector('.nav-links');
    const profileSection = document.querySelector('.profile');
    const profileName = document.querySelector('.welcome-text');
    const notificationLink = document.querySelector('.notification');

    /*user is logged in*/ 
    if (Object.keys(this.context.state.userinfoglobal).length !== 0) {
      if (this.context.state.CompanyAffilliatedCountry!=="CA") {
        if (navLinks) {
          navLinks.style.display = 'block';
        }
        if (profileSection) {
          profileSection.style.display = 'block';
        }
        if (notificationLink) {
          notificationLink.style.display = 'block';
        }
        if (profileName) {
          profileName.textContent = `${this.context.state.userinfoglobal.FirstName} ${this.context.state.userinfoglobal.LastName}`; // Set profile name
        }
      } else {
        if (navLinks) {
          navLinks.style.display = 'none';
        }
        if (notificationLink) {
          notificationLink.style.display = 'none';
        }
      }
      return (
        <div>
          {this.props.children}
        </div>
      );
    } else /*user is not logged in*/ {
      if (navLinks) {
        navLinks.style.display = 'none';
      }
      if (profileSection) {
        profileSection.style.display = 'none';
      }
      if (notificationLink) {
        notificationLink.style.display = 'none';
      }

      return (
        <div>
          <Menu onSelect={this.onSelect}>
            <MenuItem text="Home" data={{ route: "/" }} />
          </Menu>
          {this.props.children}
        </div>
      );
    }
  }
  onSelect = (event) => {
    this.props.history.push(event.item.data.route);
  };
}

export default withRouter(Nav);
